var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useRef } from "react";
import { TextElement } from "./TextElement";
import { ThreeJSOverlayContainer } from "./OverlayContainer";
export const TESTING_MODE_SIZE_FACTOR = 0.5;
export const DomText = (props) => {
    const { apiRef } = props, rest = __rest(props, ["apiRef"]);
    const textApiRef = useRef();
    return _jsx(ThreeJSOverlayContainer, { deps: Object.values(rest), apiRef: apiRef, sizeApi: (scaleFactor) => { var _a, _b; return (_a = textApiRef.current) === null || _a === void 0 ? void 0 : _a.setFontSize(((_b = rest.fontSize) !== null && _b !== void 0 ? _b : 1) * scaleFactor); }, children: _jsx(TextElement, Object.assign({}, rest, { apiRef: textApiRef })) });
};
//# sourceMappingURL=DomText.js.map